import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from '../../api.service';

@Component({
	selector: 'app-mailbox-breadcrumb',
	templateUrl: '../../breadcrumb/breadcrumb.component.html',
	styleUrl: '../../../assets/styles/breadcrumb.scss'
})
export class MailboxBreadcrumbComponent implements OnInit {
	public breadcrumbList: IBreadCrumb[];

	constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute,) {
		this.breadcrumbList = this.buildBreadCrumb(this.activatedRoute.root);
	}

	ngOnInit() {
		this.router.events.pipe(
			filter((event: Event) => event instanceof NavigationEnd),
			distinctUntilChanged(),
		).subscribe(() => {
			this.breadcrumbList = this.buildBreadCrumb(this.activatedRoute.root);
		})
	}

	buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbList: IBreadCrumb[] = []): IBreadCrumb[] {
		/*If no routeConfig is avalailable we are on the root path*/
		let name = route.routeConfig && route.routeConfig.data ? route.routeConfig.data.breadcrumb : '';
		let path: any = route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

		/*If the route is dynamic route such as ':id', remove it*/
		const lastRoutePart = path.split('/').pop();
		const isDynamicRoute = lastRoutePart.startsWith(':');
		if (isDynamicRoute && !!route.snapshot) {
			const paramName = lastRoutePart.split(':')[1];
			path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
			//name = route.snapshot.params[paramName];
		}

		/*In the routeConfig the complete path is not available, so we rebuild it each time*/
		const nextUrl = path ? `${url}/${path}` : url;

		/*Remove /app url as it is topnavbar only */
		if (name == "TopNavBar") { name = null };
		const breadcrumb: IBreadCrumb = {
			name: name,
			path: nextUrl,
		};
		/*Only adding route with non-empty name*/
		const newBreadcrumbs = breadcrumb.name ? [...breadcrumbList, breadcrumb] : [...breadcrumbList];
		if (route.firstChild) {
			/*If we are not on our current path yet, there will be more children to look after, to build our breadcumb*/
			return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
		}

		/*Insert dashboard at first*/
		const dashbreadcrumb: IBreadCrumb = {
			name: "Home",
			path: this.apiService.getHomeURL(),
		}
		newBreadcrumbs.unshift(dashbreadcrumb);
		return newBreadcrumbs;
	}

}

export interface IBreadCrumb {
	name: string;
	path: string;
	params?: any;
}